import { useEffect } from 'react';

import useAppDownloadCujModal from '@/hooks/Cuj/useAppDownloadCujModal';
import useGetFaqs from '@/hooks/magazine/useGetFaqs';
import useGetMagazines from '@/hooks/magazine/useGetMagazines';
import useCustomRouter from '@/hooks/useCustomRouter';
import { ROUTES } from '@/types/common';
import { MagazineType } from '@/types/magazine';
import { getPageName, magazineLogger } from '@/utils/logger';

const useGetMagazineViewModel = () => {
  const { magazines, magazinesIsLoading } = useGetMagazines();
  const { faqs, faqsIsLoading } = useGetFaqs();
  const { moveToPage, router } = useCustomRouter();
  const pageName = getPageName(router);
  // 글로벌 앱 설치 모달 트래킹 정보 저장
  const { setIsCujModalTrackingInfo } = useAppDownloadCujModal();

  const onClickMove = (magazinePid: string, type: MagazineType) => {
    if (type === MagazineType.FAQ) {
      moveToPage({
        webLink: `${ROUTES.FAQ.DETAIL.path}/${magazinePid}`,
        mobileScreenName: ROUTES.FAQ.DETAIL.appScreenName,
        params: {
          id: magazinePid,
        },
      });
    }

    moveToPage({
      webLink: `${ROUTES.MAGAZINE.DETAIL.path}/${magazinePid}`,
      mobileScreenName: ROUTES.MAGAZINE.DETAIL.appScreenName,
      params: {
        id: magazinePid,
      },
    });
  };

  const onClickAllList = (type: MagazineType) => {
    magazineLogger({
      pageName: getPageName(router),
      eventName: 'magazine_view_more_click',
      payload: { section_name: type },
    });

    if (type === MagazineType.FAQ) {
      moveToPage({
        webLink: `${ROUTES.FAQ.LIST.path}`,
        mobileScreenName: ROUTES.FAQ.LIST.appScreenName,
        params: {
          type: type,
        },
      });

      return;
    }
    moveToPage({
      webLink: `${ROUTES.MAGAZINE.LIST.path}/${type}`,
      mobileScreenName: ROUTES.MAGAZINE.LIST.appScreenName,
      params: {
        type: type,
      },
    });
  };

  const onClickLogMagazine = (magazinePid: string, type: MagazineType) => {
    magazineLogger({
      pageName: getPageName(router),
      eventName: 'magazine_item_click',
      payload: { magazinePid, section_name: type },
    });
  };

  useEffect(() => {
    setIsCujModalTrackingInfo({
      campaignName: 'web_content_magazine',
      trackContent: 'web_mid_mdl_main',
    });
  }, []);

  return {
    magazines,
    magazinesIsLoading,
    faqs,
    faqsIsLoading,
    onClickMove,
    onClickAllList,
    onClickLogMagazine,
    pageName,
  };
};

export default useGetMagazineViewModel;
